module.exports = __webpack_public_path__ + "img/google-tag-manager.40d8ee52.jpg";